=<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <!-- <Sidebar></Sidebar> -->

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <div class="hidden-xs">    
                        <center>
                            <img src="static/config/logo.png" class="logo-inicio">
                        </center>
                    </div>      

                    <div class="row margin-bottom-30">
                        <div class="col-xl-12">
                            <button class="margin-bottom-10 button small gray" type="button" v-on:click="$root.back()">
                                <i class="las la-arrow-left"></i> Voltar
                            </button>

                            <button class="margin-bottom-10 button small green margin-left-5" v-on:click="salvar()" type="button">
                                <i class="las la-save"></i> Salvar formulário
                            </button>

                            <button v-on:click="visualizar()" class="margin-bottom-10 button small color-blue margin-left-5" type="button">
                                <i class="las la-eye"></i> Visualizar formulário
                            </button>

                            <button v-on:click="exportar()" class="margin-bottom-10 button small color-gray margin-left-5" type="button">
                                <i class="las la-download"></i> Exportar
                            </button>                            

                        </div>
                    </div>

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs margin-bottom-20">
                        <h3>
                            <img src="static/images/icones/engineering.png" style="height: 50px">
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>


                    <!-- Row -->
                    <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">
                        <div class="row">

                            <div class="col-xl-12 col-xs-12 col-md-12 col-lg-6">
                                <div class="row">
                                    <div class="col-xl-6 col-md-12 col-lg-6">
                                        <div class="submit-field">
                                            <h5>Nome do formulário:</h5>
                                            <input type="text" class="with-border" placeholder="..." required=""  v-model="form.nome">
                                        </div>
                                    </div>
                                    <div class="col-xl-12"></div>
                                    <div class="col-xl-12 margin-bottom-15">
                                        <div class="checkbox">
                                            <input type="checkbox" id="form-ativo" v-model="form.ativo" value="1">
                                            <label for="form-ativo"><span class="checkbox-icon"></span> Formulário ativo</label>
                                        </div>                                                                          
                                    </div> 
                                </div>
                            </div>                                                   
                            <div class="col-xl-6 col-xs-12 col-md-12 col-lg-6">
                                <div class="submit-field">
                                    <h5>Select de gatilho: (opcional)</h5>
                                    <textarea class="with-border" placeholder="..."  v-model="form.queryGatilho" rows="3" style="min-height: 100px;"></textarea>
                                </div>
                            </div>
                            <div class="col-xl-6 col-xs-12 col-md-12 col-lg-6">
                                <div class="submit-field">
                                    <h5>Query de update (após rodar o gatilho): (opcional)</h5>
                                    <textarea class="with-border" placeholder="..."  v-model="form.queryUpdate" rows="3" style="min-height: 100px;"></textarea>                                    
                                </div>
                            </div>
                            <div class="col-xl-12 margin-top-15 clearfix"></div>

                            <div class="col-xl-3" v-show="tab != 'campos'">
                                <div class="submit-field margin-bottom-10">
                                    <h5>
                                        Etapas:
                                        <button type="button" class="dashboard-status-button block-mobile small gray float-right" v-on:click="addEtapa()">
                                            <i class="las la-plus"></i> Adicionar etapa
                                        </button>
                                    </h5>
                                </div>
                            </div>
                            <div class="col-xl-12">

                                <div class="row">
                                    <div class="col-xl-3 col-xs-12 col-lg-4 col-md-6" v-show="tab != 'campos'">
                                       
                                        <ul class="dashboard-box-list">

                                            <li v-if="form.etapas.length == 0">
                                                <h5 class="empty">
                                                    <i class="las la-times"></i> Nenhuma etapa cadastrada no formulário.
                                                </h5>
                                            </li>
                                            
                                            <li :id="'etapa-' + item.cod" class="click" v-bind:class="{'disabled': false}" v-for="(item, index) in form.etapas" v-on:click="setEtapa(index)">
                                                <a class="job-listing card2" v-bind:class="{'active': index == ativo}">
                                                    <div class="job-listing-details">
                                                        <div class="job-listing-description">
                                                            <div class="row">
                                                                <div class="col-lg-12 col-xl-12 col-xs-12">

                                                                    <h3 class="margin-top-5 margin-bottom-5">
                                                                        {{item.nome}}
                                                                    </h3>

                                                                    <div class="acoes">
                                                                        <a class="dashboard-status-button color-blue hidden-xs">
                                                                            <i class="las la-arrows-alt"></i> Reordenar
                                                                        </a>
                                                                        <a class="dashboard-status-button color-red" v-on:click="del('etapas', item)">
                                                                            <i class="las la-trash"></i> Apagar
                                                                        </a>
                                                                    </div>

                                                                </div>
                                                                <div class="col-lg-12 col-xl-4 col-xs-12">

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>


                                        </ul>
                                    </div>   

                                    <div class="col-xl-9 col-xs-12 col-lg-8 col-md-6" v-if="form.etapas[ativo]" v-bind:class="{'col-xl-12 col-md-12 col-lg-12': tab == 'campos'}">

                                        <div class="tabs scroll-to">
                                            <div class="tabs-header">
                                                <ul>
                                                    <li v-on:click="setTab('informacoes')" v-bind:class="{'active': tab == 'informacoes'}" class="" style="">
                                                        <a>
                                                            <i class="las la-cog"></i>
                                                            Configurações
                                                        </a>
                                                    </li>
                                                    <li v-on:click="setTab('campos')" v-bind:class="{'active': tab == 'campos'}" class="" style="">
                                                        <a>
                                                            <i class="las la-database"></i>
                                                            Campos
                                                        </a>
                                                    </li>
                                                    <li v-on:click="setTab('acoes')" v-bind:class="{'active': tab == 'acoes'}" class="" style="">
                                                        <a>
                                                            <i class="las la-robot"></i> 
                                                            Ações após envio
                                                        </a>
                                                    </li>


                                                </ul>
                                                <button class="margin-bottom-10 button small green hidden-xs hidden-md" v-if="tab == 'campos'" style="float: right; margin-top: -45px; margin-bottom: -3px; margin-right: 10px; z-index: 100;" v-on:click="salvar()" type="button">
                                                    <i class="las la-save"></i> Salvar formulário
                                                </button>
                                            </div>
                                            <!-- Tab Content -->
                                            <div class="tabs-content">

                                                <div class="tab" v-show="tab == 'informacoes'">
                                                    <div class="row">

                                                        <div class="col-xl-4 col-md-6 col-lg-6">
                                                            <div class="submit-field">
                                                                <h5>Nome da etapa:</h5>
                                                                <input type="text" class="with-border" placeholder="..." required=""  v-model="form.etapas[ativo].nome">
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-12 clearfix"></div>
                                                        <div class="col-xl-4 margin-bottom-10">
                                                            <div class="checkbox">
                                                                <input type="checkbox" :id="'checkbox-etapa-ativa' + ativo" value="1" v-model="form.etapas[ativo].ativo">
                                                                <label :for="'checkbox-etapa-ativa' + ativo"><span class="checkbox-icon"></span> Etapa ativa</label>
                                                            </div>                                                                          
                                                        </div>
                                                        <div class="col-xl-12 clearfix"></div>
                                                        <div :key="ativo + '-areas'" class="col-xl-12 col-md-12 col-lg-12 margin-top-10">
                                                            <div class="submit-field">
                                                                <h5>Áreas que possuem permissão para acesso a essa etapa do formulário:</h5>  
                                                                <select class="selectpicker" data-size="10" multiple=""  data-live-search="true" data-live-search-placeholder="Pesquise aqui.." data-allow-clear="true" title="Selecione aqui.." v-model="form.etapas[ativo].areas">
                                                                    <option default="" disabled value="">Selecione..</option>
                                                                    <option v-for="(item, index) in areas.itens" :key="'area-' + item.cod" :value="item.cod">{{item.nome}}</option>                                                              
                                                                </select>
                                                            </div>
                                                        </div>                                                        
                                           
                                                        <div :key="ativo + '-usuarios'" class="col-xl-12 col-md-12 col-lg-12 margin-top-10">
                                                            <div class="submit-field">
                                                                <h5>Usuários que possuem permissão para acesso a etapa do formulário:</h5>
                                                                <select class="selectpicker" data-size="10" multiple="" data-live-search="true" data-live-search-placeholder="Pesquise aqui.."  data-allow-clear="true" title="Selecione aqui.." v-model="form.etapas[ativo].usuarios">
                                                                    <option default="" disabled value="">Selecione..</option>                                                                   
                                                                    <option v-for="(item, index) in usuarios.itens" :key="'usuario-' + item.cod" :value="item.cod">{{item.nome}}</option>                                                              
                                                                </select>
                                                            </div>
                                                        </div>


                                                        <div class="col-xl-12 clearfix"></div>

                                                        <div class="col-xl-6 col-md-6 col-lg-10 margin-top-5">
                                                            <div class="submit-field margin-bottom-20">
                                                                <h5>Ações que serão executadas no início desta etapa:</h5>
                                                            </div>
                                                        </div>

                                                        <div class="col-xl-12 margin-bottom-10">
                                                            <div class="checkbox">
                                                                <input type="checkbox" id="checkbox-enviar-pre-email" :value="1" v-model="form.etapas[ativo].preEmailEnviar">
                                                                <label for="checkbox-enviar-pre-email"><span class="checkbox-icon"></span> Enviar e-mail</label>
                                                            </div>                                                                          
                                                        </div>                                                    
                                                        <div v-show="form.etapas[ativo].preEmailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                            <div class="submit-field">
                                                                <h5>Assunto do e-mail</h5>
                                                                <input type="text" placeholder="..." class="with-border margin-top-10" v-model="form.etapas[ativo].preEmailAssunto">
                                                            </div>
                                                        </div>

                                                        <div v-show="form.etapas[ativo].preEmailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                            <div class="submit-field">
                                                                <h5>Título do e-mail</h5>
                                                                <input type="text" placeholder="..." class="with-border margin-top-10" v-model="form.etapas[ativo].preEmailTitulo">
                                                            </div>
                                                        </div>                                            

                                                        <div v-show="form.etapas[ativo].preEmailEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                            <div class="submit-field">
                                                                <h5>Texto do e-mail</h5>
                                                                <trumbowyg v-model="form.etapas[ativo].preEmailTexto" :config="config" style="height: 200px;" class="" name="preEmailTexto"></trumbowyg>
                                                            </div>
                                                        </div>
                                                        <div v-show="form.preEmailEnviar == 1" class="col-xl-12 col-md-12 col-lg-12 margin-bottom-15">
                                                            <hr>
                                                        </div>
                                                        <div class="col-xl-12 margin-bottom-10">
                                                            <div class="checkbox">
                                                                <input type="checkbox" id="checkbox-enviar-pre-push" :value="1" v-model="form.etapas[ativo].prePushEnviar">
                                                                <label for="checkbox-enviar-pre-push"><span class="checkbox-icon"></span> Enviar notificação push</label>
                                                            </div>                                                                          
                                                        </div>      
                                                        <div v-show="form.etapas[ativo].prePushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                            <div class="submit-field">
                                                                <h5>Título da notificação</h5>
                                                                <input type="text" placeholder="..." v-model="form.etapas[ativo].prePushTitulo" class="with-border margin-top-10">
                                                            </div>
                                                        </div>
                                                        <div v-show="form.etapas[ativo].prePushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                            <div class="submit-field">
                                                                <h5>Link (opcional)</h5>
                                                                <input type="text" placeholder="..." v-model="form.etapas[ativo].prePushLink" class="with-border">
                                                            </div>
                                                        </div>
                                                        <div v-show="form.etapas[ativo].prePushEnviar == 1" class="col-xl-12 col-md-12 col-lg-12 col-xs-12">
                                                            <div class="submit-field">
                                                                <h5>Texto da notificação</h5>
                                                                <textarea placeholder="..." class="with-border margin-top-10" v-model="form.etapas[ativo].prePushTexto" style="min-height: 180px;"></textarea>
                                                            </div>
                                                        </div>        

                                                    </div>
                                                </div>
                                                <div class="tab" v-show="tab == 'campos'" style="padding: 0px">
                                                    
                                                    <iframe :src="'static/form-builder.html?cod=' + form.cod + '&etapa=' + ativo" style="height: calc(100vh - 70px); width: 100%; border: none !important;"></iframe>

                                                </div>
                                                <div class="tab" v-show="tab == 'acoes'">
                                                    <div class="row">


                                                        <div class="col-xl-6 col-md-6 col-lg-6">
                                                            <div class="submit-field">
                                                                <h5>Mensagem de sucesso (opcional):</h5>
                                                                <input type="text" class="with-border" placeholder="..." required=""  v-model="form.etapas[ativo].mensagemSucesso">
                                                            </div>
                                                        </div>

                                                        <div class="col-xl-12 margin-bottom-15">
                                                            <div class="checkbox">
                                                                <input type="checkbox" id="checkbox-proxima-etapa" :value="1" v-model="form.etapas[ativo].proximaEtapaRedirecionamento">
                                                                <label for="checkbox-proxima-etapa"><span class="checkbox-icon"></span> Após envio, redirecionar usuário para a próxima etapa</label>
                                                                <small class="block">Certifique-se de que o usuário terá permissão para visualizar a próxima etapa.</small>
                                                            </div>                                                                          
                                                        </div>   

                                                        <div class="col-xl-6 col-md-6 col-lg-6" v-bind:class="{'disabled': form.etapas[ativo].proximaEtapaRedirecionamento}">
                                                            <div class="submit-field">
                                                                <h5>Link de redirecionamento (opcional):</h5>
                                                                <input type="text" :disabled="form.etapas[ativo].proximaEtapaRedirecionamento" class="with-border margin-bottom-5" placeholder="https://.." required=""  v-model="form.etapas[ativo].linkRedirecionamento">
                                                                <small class="block">Se nenhum link for informado, o usuário será redirecionado para a tela "Formulários pendentes".</small>
                                                            </div>
                                                        </div>                                                        

                                                        <div class="col-xl-12 col-xs-12 col-md-12 col-lg-12">
                                                            <div class="submit-field">
                                                                <h5>Query de insert com as informações: (opcional)</h5>
                                                                <small class="block">Variáveis disponíveis:</small>
                                                                <span v-on:click="form.etapas[ativo].queryInsert += '{' + item + '}'" class="dashboard-status-button gray click margin-right-5" v-for="item in form.etapas[ativo].variaveis">{{'{' + item + '}'}}</span>
                                                                <textarea class="with-border margin-top-10" placeholder="..."  v-model="form.etapas[ativo].queryInsert" rows="10"></textarea>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-12 clearfix"></div>
                                                        <div class="col-xl-12 margin-bottom-10">
                                                            <div class="checkbox">
                                                                <input type="checkbox" id="checkbox-enviar-pos-email" :value="1" v-model="form.etapas[ativo].posEmailEnviar">
                                                                <label for="checkbox-enviar-pos-email"><span class="checkbox-icon"></span> Enviar e-mail</label>
                                                            </div>                                                                          
                                                        </div>                                                    
                                                        <div v-show="form.etapas[ativo].posEmailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                            <div class="submit-field">
                                                                <h5>Assunto do e-mail</h5>
                                                                <small class="block">Variáveis disponíveis:</small>
                                                                <span v-on:click="form.etapas[ativo].posEmailAssunto += '{' + item + '}'" class="dashboard-status-button gray click margin-right-5" v-for="item in form.etapas[ativo].variaveis">{{'{' + item + '}'}}</span>                                                                
                                                                <input type="text" placeholder="..." class="with-border margin-top-10" v-model="form.etapas[ativo].posEmailAssunto">
                                                            </div>
                                                        </div>

                                                        <div v-show="form.etapas[ativo].posEmailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                            <div class="submit-field">
                                                                <h5>Título do e-mail</h5>
                                                                <small class="block">Variáveis disponíveis:</small>
                                                                <span v-on:click="form.etapas[ativo].posEmailTitulo += '{' + item + '}'" class="dashboard-status-button gray click margin-right-5" v-for="item in form.etapas[ativo].variaveis">{{'{' + item + '}'}}</span>                                                                        
                                                                <input type="text" placeholder="..." class="with-border margin-top-10" v-model="form.etapas[ativo].posEmailTitulo">
                                                            </div>
                                                        </div>                                            

                                                        <div v-show="form.etapas[ativo].posEmailEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                            <div class="submit-field">
                                                                <h5>Texto do e-mail</h5>
                                                                <small class="block">Variáveis disponíveis:</small>
                                                                <span v-on:click="form.etapas[ativo].posEmailTexto += '{' + item + '}'" class="dashboard-status-button gray click margin-right-5" v-for="item in form.etapas[ativo].variaveis">{{'{' + item + '}'}}</span>      
                                                                <div style="height: 10px"></div>                                                          
                                                                <trumbowyg v-model="form.etapas[ativo].posEmailTexto" :config="config" style="height: 200px;" class="" name="posEmailTexto"></trumbowyg>
                                                            </div>
                                                        </div>
                                                        <div v-show="form.posEmailEnviar == 1" class="col-xl-12 col-md-12 col-lg-12 margin-bottom-15">
                                                            <hr>
                                                        </div>
                                                        <div class="col-xl-12 margin-bottom-10">
                                                            <div class="checkbox">
                                                                <input type="checkbox" id="checkbox-enviar-pos-push" :value="1" v-model="form.etapas[ativo].posPushEnviar">
                                                                <label for="checkbox-enviar-pos-push"><span class="checkbox-icon"></span> Enviar notificação push</label>
                                                            </div>                                                                          
                                                        </div>      
                                                        <div v-show="form.etapas[ativo].posPushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                            <div class="submit-field">
                                                                <h5>Título da notificação</h5>
                                                                <small class="block">Variáveis disponíveis:</small>
                                                                <span v-on:click="form.etapas[ativo].posPushTitulo += '{' + item + '}'" class="dashboard-status-button gray click margin-right-5" v-for="item in form.etapas[ativo].variaveis">{{'{' + item + '}'}}</span>                                                                   
                                                                <input type="text" placeholder="..." v-model="form.etapas[ativo].posPushTitulo" class="with-border margin-top-10">
                                                            </div>
                                                        </div>
                                                        <div v-show="form.etapas[ativo].posPushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                            <div class="submit-field">
                                                                <h5>Link (opcional)</h5>
                                                                <input type="text" placeholder="..." v-model="form.etapas[ativo].posPushLink" class="with-border">
                                                            </div>
                                                        </div>
                                                        <div v-show="form.etapas[ativo].posPushEnviar == 1" class="col-xl-12 col-md-12 col-lg-12 col-xs-12">
                                                            <div class="submit-field">
                                                                <h5>Texto da notificação</h5>
                                                                <small class="block">Variáveis disponíveis:</small>
                                                                <span v-on:click="form.etapas[ativo].posPushTexto += '{' + item + '}'" class="dashboard-status-button gray click margin-right-5" v-for="item in form.etapas[ativo].variaveis">{{'{' + item + '}'}}</span>                                                                   
                                                                <textarea placeholder="..." class="with-border margin-top-10" v-model="form.etapas[ativo].posPushTexto" style="min-height: 180px;"></textarea>
                                                            </div>
                                                        </div>        

                                                    </div>
                                                </div>                                                                                                

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'


const creatorOptions = {
    showLogicTab: true,
    isAutoSave: true
};

export default {
    name:                           'GerenciarFormularios',
    components: {
        'Trumbowyg':                VueTrumbowyg.default,
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            config: {
                svgPath:            "https://cdnjs.cloudflare.com/ajax/libs/Trumbowyg/2.20.0/ui/icons.svg",
                btns: [
                    ['undo', 'redo'],
                    ['formatting'],
                    ['fontsize'],
                    ['strong', 'em', 'del'],
                    ['link'],
                    // ['insertImage'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['unorderedList', 'orderedList'],
                    ['horizontalRule'],
                    ['removeformat'],
                    // ['fullscreen']
                ]
            },              
            "ativo":                -1,
            "tab":                  "",
            "loading": {
                "submit":           false
            },
            "usuarios": {
                "itens": [],
                "loaded": false
            },
            "areas": {
                "itens": [],
                "loaded": false
            },            
            "form": {
                "_cod":             "",
                "_token":           "",
                "cod":              "",
                "nome":             "",
                "ativo":            1,
                "tipo":             "",
                "queryGatilho":     "",
                "etapas": [
                
                ]
            }            
        }
    },
    watch: {
    },
    methods: {
        exportar: function() {
            var self = this;

            const filename = 'formulario-' + self.form.cod + '.json';
            var form2 = JSON.parse(JSON.stringify(self.form));
            delete form2.id;
            const jsonStr = JSON.stringify(form2);

            let element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(jsonStr));
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);

        },
        getAreas: function() {
            var self        = this;
            console.log("getAreas()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/areas.php", form)
                .then(response => {
                    
                    console.log("getAreas() response", response);

                    response.data.result.itens = response.data.result.itens.map(function(item) {
                        return {
                            "id":   item.id,
                            "cod":  item.cod,
                            "nome": item.nome
                        }
                    });

                    self.areas       = response.data.result; 
                    loading.hide();
                    self.$forceUpdate();
                    resolve(response.data.result);

                    setTimeout(function() {
                        $(".selectpicker").selectpicker();
                    }, 100);

                })
                .catch(error => {
                    console.log("getAreas() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },   
        getUsuarios: function() {
            var self        = this;
            console.log("getUsuarios()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "!contratante"
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("getUsuarios() response", response);

                    response.data.result.itens = response.data.result.itens.map(function(item) {
                        return {
                            "id":   item.id,
                            "cod":  item.cod,
                            "nome": item.nome
                        }
                    });

                    self.usuarios       = response.data.result; 
                    loading.hide();
                    self.$forceUpdate();
                    resolve(response.data.result);

                    setTimeout(function() {
                        $(".selectpicker").selectpicker();
                    }, 100);

                })
                .catch(error => {
                    console.log("getUsuarios() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },            
        addEtapa: function() {
            var self = this;
            self.form.etapas.push({
                "cod":  md5((new Date().getTime()) + Math.random() + Math.random()),
                "nome": "Etapa " + (self.form.etapas.length +1),
                "ordem": (self.form.etapas.length +1),
                "ativo": 1,
                "areas": [
                ],
                "usuarios": [
                ],
                "formulario":   {},
                "queryInsert":  "",
                "preEmailEnviar":  0,
                "preEmailAssunto": "",
                "preEmailTitulo":  "",
                "preEmailTexto":   "",
                "prePushEnviar":   0,
                "prePushTitulo":   "",
                "prePushTexto":    "",
                "posEmailEnviar":  0,
                "posEmailAssunto": "",
                "posEmailTitulo":  "",
                "posEmailTexto":   "",
                "posPushEnviar":   0,
                "posPushTitulo":   "",
                "posPushTexto":    "",                
            });

            if (self.form.etapas.length == 1) {
                self.setEtapa(0);
            }

            self.atualizarSortable();
        },
        del: function(field, val) {
            var self = this;
            confirm("Você tem certeza que deseja apagar esse item?", function(c) {
                var index = self.form[field].indexOf(val);
                if (index != -1) {

                    if (index == self.ativo) {
                        self.ativo = -1;
                    }

                    self.form[field].splice(index, 1);
                    self.$forceUpdate();
                }
            });

        },        
        visualizar: function() {
            var self = this;
            if (!window.cordova) {
                window.open("#/formulario?demo=true&formularioCod=" + self.form.cod, "_system");
                // window.open(self.$root.config.url + "#/formulario?formularioCod=" + self.form.cod, "_system");
            } else {
                self.$root.go("Formulario", JSON.stringify({"formularioCod": self.form.cod, "demo": true}));
            }
        },
        setEtapa: function(index) {
            var self    = this;
            self.ativo  = index;

            if (!self.form.etapas[index].cod) {
                self.form.etapas[index].cod = md5((new Date().getTime()) + Math.random() + Math.random());
            }

            self.$forceUpdate();
            self.setTab("informacoes");

        },
        atualizarSortable: function() {
            var self = this;
            console.log("atualizarSortable()");
            setTimeout(function() {
                $( ".dashboard-box-list" ).sortable({
                    stop: function( event, ui ) {
                        console.log("on stop sortable", event, ui);

                        var list = $( ".dashboard-box-list" ).sortable( "toArray" );
                        list.forEach(function(item, index) {
                            item = item.replace("etapa-", "");
                            self.form.etapas.forEach(function(item2, index2) {
                                if (item2.cod == item) {
                                    self.form.etapas[index2].ordem = (index+1);
                                }
                            });

                        });

                        self.$forceUpdate();
                    }
                });
            }, 500);            
        },
        setTab: function(tab) {
            var self = this;
            self.tab = tab;
            loading.show();

            if (tab == "campos") {
                $(".dashboard-content-inner").addClass("no-scroll");
                $(".dashboard-content-inner").addClass("no-padding");
                window.__parent.postMessage({
                    "nome":         "setForm",
                    "formulario":   self.form.etapas[self.ativo].formulario
                }, "*");   

                loading.show();
                $(".dashboard-content-inner")[0].scrollTo({
                    top:            0
                });                        
                setTimeout(function() {
                    $(".dashboard-content-inner")[0].scrollTo({
                        top:            $(".scroll-to")[0].getBoundingClientRect().top - (window.__app.mobile.isMobile ? 70 : 0),
                        behavior:       "instant"
                    });             
                    setTimeout(function() {
                        loading.hide();
                    }, 500);                    
                }, 1);       
                self.$forceUpdate();
                return false;             
            } else {
                $(".dashboard-content-inner").removeClass("no-scroll");
                $(".dashboard-content-inner").removeClass("no-padding");
            }

            self.$forceUpdate();


            if (tab == "informacoes") {
                setTimeout(function() {
                    $(".selectpicker").selectpicker();
                    $('select').on('shown.bs.select', function (e, clickedIndex, isSelected, previousValue) {
                        $(".tab").css('height', '100vh');
                    });

                    $('select').on('hidden.bs.select', function (e, clickedIndex, isSelected, previousValue) {
                        $(".tab").css('height', 'auto');
                    });
                }, 500);                
            }
            setTimeout(function() {
                loading.hide();
            }, 500);                  
        },
        salvar: function() {
            var self            = this;
            console.log("submit()", self.form);

            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.id) {
                a = "put";
            }

            axios[a]("api/formularios.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                self.form.id    = response.data.result.id;
                self.form.cod   = response.data.result.cod;
                loading.hide();
                alert(response.data.message);
                // self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/formularios.php", form)
                .then(response => {
                    
                    console.log("get() response", response);

                    function decodeHTMLEntities(text) {
                      return $("<textarea/>")
                        .html(text)
                        .text();
                    }

                    response.data.result.etapas.forEach(function(item, i) {
                        response.data.result.etapas[i].emailTexto = decodeHTMLEntities(item.emailTexto);
                    });

                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    self.$forceUpdate();

                    if (self.form.etapas.length > 0) {
                        self.setEtapa(0);
                    }

                    self.atualizarSortable();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        init: function() {

            var self = this;
            console.log("init()", self.$route)
            if (self.$route.name == "EditarFormularios") {
                if (!self.$route.query.c) {
                    self.$root.back();
                    return false;
                }
                self.form.cod = self.$route.query.c;
                self.get();
            } else {
                self.form.cod = md5( (new Date().getTime()) + Math.random() );
                self.addEtapa();
                loading.hide();
            }

            self.getUsuarios();
            self.getAreas();

            var eventMethod     = window.addEventListener ? "addEventListener" : "attachEvent";
            self.messageEvent   = eventMethod === "attachEvent" ? "onmessage" : "message";
            window._onMessage   = function (e) {
            
                console.log("on message >", e);

                var permitido = ["change", "updateComponent", "deleteComponent", "editComponent", "cancelComponent"];

                if (typeof e.data != "string") {
                    if (e.data.nome == "init") {
                        window.__parent =  event.source;
                    }

                    if (permitido.indexOf(e.data.nome) != -1) {
                        self.form.etapas[self.ativo].formulario     = e.data.formulario;
                        self.form.etapas[self.ativo].queryDados     = e.data.queryDados;
                        self.form.etapas[self.ativo].variaveis      = e.data.variaveis;
                        self.form.etapas[self.ativo].uploadArquivos = e.data.uploadArquivos;
                        console.log("Setou formulario:", self.form.etapas[self.ativo]);
                    }
                }
            }
            window.removeEventListener("onmessage", window._onMessage, false);
            window.removeEventListener("message", window._onMessage, false);                

            var eventer     = window[eventMethod];
            eventer(self.messageEvent, window._onMessage);            

        }
    },    
    activated: function() {
        var self = this;
        console.log("activated", self);
        self.init();
    },
    created: function() {
        var self = this;
        console.log("created", self);
        self.init();
    },
    mounted: function() {
        var self = this;

    }     
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>


    @media only screen and (max-width: 500px) { 
        
        .dashboard-box-list {
            height: auto !important;
        }
    }

    .job-listing {
        width: 100%;
    }

    .job-listing-details {
        padding: 10px 10px 20px 10px;
    }

    ul.dashboard-box-list>li {
        padding: 0px;
    }

    .job-listing-details span.block {
        color: #999;
    }

    .dashboard-box-list {
        height: 100vh;
        overflow-y: scroll;
/*        background: #f7f7f7;*/
        border-radius: 6px;
    }

    .tab {
        opacity: 1;
        display: block;
    }

    .tabs {
        border-radius: 6px !important;
        border: 1px solid #ddd;
        box-shadow: none;
    }
    .tabs-header {
        background: #f7f7f7;
    }

    .tabs-header li {
        cursor: pointer;
    }

    .tabs-header li a {
        color: #333;
    }

    .tabs-header li.active a {
        background: var(--theme-color-primary) !important;
        color: #fff !important;
    }

    .job-listing.card2 { 
        border-width: 1px !important;
    }


    h5 .dashboard-status-button {
        padding: 1px 10px;
        font-size: 14px;
    }

    .job-listing.active {
        background: #f7f7f7 !important;
    }

    .acoes {
        margin-top: 5px;
    }

    .acoes .dashboard-status-button {
        font-size: 12px !important;
        padding: 0px 5px !important;
    }

    textarea {
        font-weight: 400;
        color: #000;
        line-height: 130%;
        padding: 10px;
/*        border-radius: 0px !important;*/
    }
</style>



// WEBPACK FOOTER //
// src/components/GerenciarFormularios.vue